import { customRuleGroupApi, underwriterApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { addClonedRulesAction, addRulesAction } from './rules.actions';

export const RULE_GROUPS_ACTION_TYPE = createNamedActions('ruleGroups', {
  GET_RULE_GROUPS: 'GET_RULE_GROUPS',
  GET_RULE_GROUP_BY_ID: 'GET_RULE_GROUP_BY_ID',
  ADD_RULE_GROUP: 'ADD_RULE_GROUP',
  EDIT_RULE_GROUP: 'EDIT_RULE_GROUP',
  DELETE_RULE_GROUP: 'DELETE_RULE_GROUP',
  TEST_RULE_GROUPS: 'TEST_RULE_GROUPS',
  CLONE_RULE_GROUP: 'CLONE_RULE_GROUP',
});

const ruleGroups = new schema.Entity('ruleGroups', {}, { idAttribute: 'id' });

const separateRulesAndRuleGroups = data =>
  data.reduce(
    (acc, { rules, ...rest }) => {
      return { rules: [...acc.rules, ...(rules || [])], groups: [...acc.groups, rest] };
    },
    { rules: [], groups: [] },
  );

const flattenRuleGroupTree = ({ children, ...group }) => [
  group,
  ...(children || []).flatMap(flattenRuleGroupTree),
];

export const getRuleGroupsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customRuleGroupApi.getCustomRuleGroup();

  const { rules, groups } = separateRulesAndRuleGroups(data);

  dispatch({
    type: RULE_GROUPS_ACTION_TYPE.GET_RULE_GROUPS,
    payload: normalize(groups, [ruleGroups]).entities.ruleGroups,
  });

  dispatch(addRulesAction(rules));
});

export const getRuleGroupByIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customRuleGroupApi.getCustomRuleGroupById(params);

  return dispatch({
    type: RULE_GROUPS_ACTION_TYPE.GET_RULE_GROUP_BY_ID,
    payload: data,
  });
});

export const addRuleGroupAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleGroupApi.createCustomRuleGroup(body);

  return dispatch({
    type: RULE_GROUPS_ACTION_TYPE.ADD_RULE_GROUP,
    payload: data,
  });
});

export const editRuleGroupAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customRuleGroupApi.editCustomRuleGroup(params);

  return dispatch({
    type: RULE_GROUPS_ACTION_TYPE.EDIT_RULE_GROUP,
    payload: data,
  });
});

export const deleteRuleGroupAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customRuleGroupApi.deleteCustomRuleGroup(params);

  return dispatch({
    type: RULE_GROUPS_ACTION_TYPE.DELETE_RULE_GROUP,
    payload: data,
  });
});

export const testRuleGroupsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwriterApi.createUnderwriterSpecificScenarioVerify(params);

  return dispatch({
    type: RULE_GROUPS_ACTION_TYPE.TEST_RULE_GROUPS,
    payload: data,
  });
});

export const cloneRuleGroupAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleGroupApi.createCustomRuleGroupCloneHierarchically(body);

  const { rules, groups } = separateRulesAndRuleGroups(flattenRuleGroupTree(data));

  dispatch({
    type: RULE_GROUPS_ACTION_TYPE.CLONE_RULE_GROUP,
    payload: groups,
  });

  dispatch(addClonedRulesAction(rules));
});
